import script from "./OrderDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderDetail.vue?vue&type=script&setup=true&lang=ts"

import "./OrderDetail.vue?vue&type=style&index=0&id=43d9dffa&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43d9dffa"]])

export default __exports__